import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {InsightsDetailsTypeEnums} from '../../../../enums/profile-enums';
import {DatePipe, DecimalPipe} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {PAGES_AND_PATHS} from '../../../../constants/pages-and-paths';
import {SettingsHttpService} from '../../../../services/http-services/settings/settings-http.service';

@Component({
  selector: 'tl-insights-single-list',
  standalone: true,
  imports: [
    DecimalPipe,
    TranslateModule
  ],
  providers: [DatePipe],
  templateUrl: './insights-single-list.component.html',
})
export class InsightsSingleListComponent implements OnChanges {
  @Input() urlParams: {from_date: string | null, to_date: string | null} = {from_date: null, to_date: null};
  @Input() listId!: number;
  @Output() clickOnCard: EventEmitter<string> = new EventEmitter<string>();
  selectedDate: any;
  selectedFilter = '';
  insightsListOverview: any;
  protected readonly InsightsDetailsTypeEnums = InsightsDetailsTypeEnums;
  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
  constructor(private settingsHttpService: SettingsHttpService) { }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes.urlParams) {
      this.urlParams = changes.urlParams.currentValue;
      this.getInsightsSingleListOverview();
    }
  }

  getInsightsSingleListOverview(): void {
    this.settingsHttpService.getInsightsListOverview({...this.urlParams, listId: this.listId}).then(res => {
      this.insightsListOverview = res.data;
    });
  }
}
